<template>
  <div class="animated revealUp">
    <div class="white-wrapper">
      <div class="section-title">{{ $t("occupancyreport") }}</div>
      <div class="mt-3 mb-4 border-bottom">
        <div class="row">
          <div class="col-lg-6 col-xl-3 align-self-center mb-3">
            <div class="input-material">
              <div class="add-datepicker">
                <button
                  class="btn-clearDate"
                  @click.prevent="onDateHandler($event)"
                >
                  ✖
                </button>
                <Datepicker
                  :monday-first="true"
                  ref="programaticOpen"
                  v-validate="'required'"
                  :value="selectedDate"
                  typeable
                  @selected="onDateHandler($event)"
                ></Datepicker>
                <label :class="'active'">{{ $t("date") }}</label>
              </div>
            </div>
          </div>

          <div class="col-lg-6 col-xl-3 align-self-center mb-3">
            <div class="dropdown-curve-container mr-2">
              <label
                :class="
                  selectedCinema && selectedCinema.cine_id ? 'shift-up' : ''
                "
                >{{ $t("select") }} {{ $tc("cinema", 1) }}</label
              >
              <b-dropdown
                :disabled="isRoleID"
                :text="selectedCinema.cine_name"
                class="w-100"
                variant="dropdown-curve"
              >
                <div class="px-2 pb-2">
                  <input
                    v-model="searchCinema"
                    autofocus
                    class="form-control form-control-sm"
                    :placeholder="$tc('searchCinema')"
                    required
                    type="search"
                    v-on:keydown="onSearchCinema()"
                    v-on:keyup="onSearchCinema()"
                    v-on:search="onSearchCinema()"
                  />
                </div>
                <b-dropdown-item
                  v-for="(dropdownItem, dropdownIndex) in Cinemas"
                  :key="dropdownIndex"
                  @click="
                    cineDropDownHandler({
                      event: $event,
                      name: 'Cinema',
                      selectedItem: dropdownItem,
                      index: dropdownIndex
                    });
                    searchCinema = '';
                    onSearchCinema();
                    onSelectCinema(dropdownItem);
                  "
                  >{{ dropdownItem.cine_name }}
                </b-dropdown-item>
              </b-dropdown>
            </div>
          </div>

          <div class="col-lg-6 col-xl-3 align-self-center mb-3">
            <div class="dropdown-curve-container mr-2">
              <label
                :class="
                  selectedScreen &&
                  (selectedScreen.screen_id ||
                    selectedScreen.screen_name === 'All')
                    ? 'shift-up'
                    : ''
                "
                >{{ $tc("screen", 1) }}</label
              >
              <b-dropdown
                :disabled="isRoleID"
                :text="selectedScreen.screen_name"
                class="w-100"
                variant="dropdown-curve"
              >
                <b-dropdown-item
                  v-for="(dropdownItem, dropdownIndex) in CineScreens"
                  :key="dropdownIndex"
                  @click="
                    cineScreenDropDownHandler({
                      event: $event,
                      name: 'Screen',
                      selectedItem: dropdownItem,
                      index: dropdownIndex
                    })
                  "
                  >{{ dropdownItem.screen_name }}
                </b-dropdown-item>
                <b-dropdown-item
                  key="allscreens"
                  @click="
                    cineScreenDropDownHandler({
                      event: $event,
                      name: 'Screen',
                      selectedItem: { screen_id: null, screen_name: 'All' },
                      index: 0
                    })
                  "
                >
                  All
                </b-dropdown-item>
              </b-dropdown>
            </div>
          </div>

          <div class="col-lg-6 col-xl-3 align-self-center mb-3">
            <button class="btn-blue-lg w-100" @click="onFetchReport()">
              {{ $t("fetch") }} {{ $t("report") }}
            </button>
          </div>
          <div class="col-md-3 align-self-center"></div>
        </div>
      </div>

      <!-- Table Desktop/Tablet View -->
      <div class="swc-report" v-if="!isMobile">
        <div
          class="d-flex justify-content-end align-items-center"
          v-if="PdfPath"
        >
          <div>{{ $t("download") }} as:&nbsp;</div>
          <a :href="PdfPath" target="_blank" download title="Download as PDF">
            <img src="@/assets/img/icons/pdf-icon.svg" height="25" width="25" />
          </a>
           <a
            v-if="ExcelPath"
            :href="BASE_URL + ExcelPath"
            title="Download as Excel"
            download
          >
            <img src="@/assets/img/icons/excel.svg" height="25" width="25" />
          </a>
          <!-- <img @click="ExportExcel('xlsx')" src="@/assets/img/icons/excel.svg" height="25" width="25" /> -->
        </div>
        <div
          class="pos-schedule-container"
          style="position: unset; height: unset"
          ref="exportable_table"
        >
          <div>
            <header
              class="pos-schedule-header"
              style="background-color:#c4c5c6;"
            >
              <div
                class="col-lg-3 border-right h-100 d-flex align-items-center justify-content-center"
              >
                <strong>{{ $tc("movie", 1) }}</strong>
              </div>
              <div class="col-lg-9">
                <div class="row align-items-center">
                  <div class="col-lg-12">
                    <div class="row schedule-header-titles">
                      <div
                        class="col-2 d-flex align-items-center justify-content-center"
                      >
                        <strong>{{ $t("time") }}</strong>
                      </div>
                      <div
                        class="col-2 text-center d-flex align-items-center justify-content-center"
                      >
                        <strong>{{ $t("SeatType") }}</strong>
                      </div>
                      <div
                        class="col-1 text-center d-flex align-items-center justify-content-center"
                      >
                        <strong>{{ $t("admits") }}</strong>
                      </div>
                      <div
                       :class="AUTO_ADMIT_TICKET_AFTER_SHOW == 'Y' ? 'col-1' : 'col-1'"
                        class="d-flex align-items-center justify-content-center"
                      >
                        <strong>{{ $t("entered") }}</strong>
                      </div>
                      <div
                        v-if="AUTO_ADMIT_TICKET_AFTER_SHOW == 'Y'"
                        class="col-2 d-flex align-items-center justify-content-center"
                      >
                        <strong>{{ $t("autoentered") }}</strong>
                      </div>
                      
                      <div
                        class="col-1 d-flex align-items-center justify-content-center"
                      >
                        <strong>{{ $t("unpaid") }}</strong>
                      </div>
                      <div
                        class="col-1 d-flex align-items-center justify-content-center"
                      >
                        <strong>{{ $t("available") }}</strong>
                      </div>
                      <div
                        class="col-1 d-flex align-items-center justify-content-center"
                      >
                        <strong>{{ $tc("screen", 1) }}</strong>
                      </div>
                      <div
                        class="col-1 d-flex align-items-center justify-content-center"
                      >
                        <strong>{{ 'Occ %' }}</strong>
                      </div>
                    </div>
                  </div>
                  <!-- <div class="col-lg-2">
                    <div class="row">
                      <div class="col-lg-6 py-2 px-0 text-center">
                        <strong>{{ $tc('screen', 1) }}</strong>
                      </div>
                    </div>
                  </div> -->
                </div>
              </div>
            </header>

            <div class="pos-schedule-wrapper">
              <div class="col-12 mx-2" v-if="scheduleShows.length == 0">
                <NoRecords />
              </div>
              <div
                v-else
                v-for="(show, showIndex) in scheduleShows"
                :key="showIndex"
                :class="[
                  'col-12',
                  scheduleShows.length - 1 !== showIndex
                    ? 'border-bottom border-bottom-gray'
                    : ''
                ]"
              >
                <!-- {{show}} -->
                <div class="row">
                  <div class="col-lg-3 border-right pt-2">
                    <strong>{{ show[0].movie_title }}</strong>
                    <span class="text-blue small font-weight-bold ml-1"
                      >({{ show[0].mf_name }})</span
                    >
                    <div class="text-muted d-block">
                      {{ $tc("language", 1) }}: {{ show[0].lang_name }}
                    </div>
                    <div class="text-muted d-block">
                      {{ $tc("genre", 1) }}: {{ show[0].genre_name }}
                    </div>
                  </div>
                  <div class="col-lg-9">
                    <div class="row">
                      <div class="col-12">
                        <div class="row h-100">
                          <div class="col-12">
                            <div class="row">
                              <div
                                v-for="(showTime, showTimeIndex) in show"
                                :key="showTimeIndex"
                                class="col-12"
                              >
                                <div class="row">
                                  <div class="col-2 py-2 d-flex align-items-center">
                                    {{ showTime.ss_start_show_time }} -
                                    {{ showTime.ss_end_show_time }}
                                    <br />
                                    <!-- <strong>Interval Time: </strong>
                                    {{ showTime.interval_time_in_mins || showTime.cine_interval_time_in_mins }} mins
                                    <br />
                                    <strong>Cleaning Time: </strong>
                                    {{ showTime.cleaning_time_in_mins || showTime.cine_cleaning_time_in_mins }} mins
                                    <br />
                                    <strong>Advertisement Time: </strong>
                                    {{ showTime.ads_time_in_mins || showTime.cine_setting_ads_time_in_mins }} mins -->
                                  </div>
                                  <div class="col-2 px-0 border-left">
                                    <ul
                                      v-for="(seattype,
                                      seattypeIndex) in showTime.seat_type"
                                      :key="seattypeIndex"
                                      class="list-unstyled m-0"
                                    >
                                      <li
                                        class="border-bottom text-center py-2"
                                      >
                                        {{ seattype.sst_seat_type }}
                                      </li>
                                    </ul>
                                  </div>
                                  <div
                                    class="col-1 px-0 border-left text-center"
                                  >
                                    <ul
                                      v-for="(seattype,
                                      seattypeIndex) in showTime.seat_type"
                                      :key="seattypeIndex"
                                      class="list-unstyled m-0"
                                    >
                                      <li
                                        class="border-bottom text-center py-2"
                                      >
                                        {{ seattype.total_admits_by_SeatType }}
                                      </li>
                                    </ul>
                                    <!-- <b>{{showTime.total_admits}}/{{showTime.total_seats}}</b> -->
                                  </div>
                                 
                                  <div v-if="AUTO_ADMIT_TICKET_AFTER_SHOW == 'Y'" class="col-1 py-2 border-left text-right d-flex align-items-center">
                                    {{ showTime.entered - parseInt(showTime.auto_entered || 0) || 0 }}
                                  </div>
                                  <div v-else class="col-1 py-2 border-left text-right">
                                    {{ showTime.entered || 0 }}
                                  </div>
                                   <div v-if="AUTO_ADMIT_TICKET_AFTER_SHOW == 'Y'" class="col-2 py-2 border-left text-right d-flex align-items-center">
                                    {{ showTime.auto_entered || 0 }}
                                  </div>
                                  <div class="col-1 py-2 border-left d-flex align-items-center">
                                    {{ showTime.unpaid_bookings }}
                                  </div>
                                  <div class="col-1 py-2 border-left d-flex align-items-center">
                                    {{ showTime.seats_available }}
                                  </div>
                                  <div class="col-1 py-2 border-left d-flex align-items-center">
                                    {{ showTime.screen_name }}
                                  </div>
                                  <div class="col-1 py-2 border-left d-flex align-items-center">
                                    {{ parseFloat((showTime.total_admits / showTime.total_seats) * 100).toFixed(2) }}%
                                  </div>
                                  <div
                                    class="col-12 border-top bg-transparent-blue"
                                  >
                                    <div class="row">
                                      <div class="col-5 py-2 text-right">
                                        Total
                                      </div>
                                      <div
                                        v-if="showTime"
                                        class="col-2 py-2 border-left"
                                      >
                                        <progress-bar
                                          :options="options"
                                          :value="
                                            (showTime.total_admits /
                                              showTime.total_seats) *
                                              100
                                          "
                                        />
                                        <!-- <strong
                                          class="text-blue"
                                        >{{ showTime && showTime['seat_type'] && showTime['seat_type'].length > 0 ? showTime['seat_type'].reduce((ac,x)=> ac += x.total_admits_by_SeatType ,0) : "-" }} / {{show[0].total_seats}}</strong> -->
                                        <strong class="text-blue"
                                          >{{
                                            showTime && showTime.total_admits
                                          }}
                                          / {{ showTime.total_seats }}</strong
                                        >
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <!-- <div class="col-2 h-100">
                            <div class="row h-100">
                              <div
                                class="col-6 px-0 border-left border-right border-bottom d-flex align-items-center justify-content-center"
                              >
                                <div class="text-blue">{{show[0].screen_name}}</div>
                              </div>
                            </div>
                          </div> -->
                        </div>
                      </div>
                      <!-- <div class="col-12 bg-transparent-blue">
                        <div class="row">
                          <div class="col-10">
                            <div class="row">
                              <div class="col-5 py-2 text-right">
                                <div>Total</div>
                              </div>
                              <div class="col-2 py-2 border-left">
                                <strong
                                  class="text-blue"
                                >{{show[0].total_admits}} / {{show[0].total_seats}}</strong>
                              </div>
                              <div class="col-5 border-left"></div>
                            </div>
                          </div>
                        </div>
                      </div>-->
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Table Mobile View -->
      <div class="mobile-occupancy-report" v-if="isMobile">
        <article
          class="mobile-occupancy-sub-report"
          v-for="(show, showIndex) in scheduleShows"
          :key="showIndex"
        >
          <div
            class=""
            v-for="(showTime, showTimeIndex) in show"
            :key="showTimeIndex"
          >
            <div
              class="sub-report-toggle section-title section-border"
              v-b-toggle="`table-${showIndex}`"
            >
              <div class="pr-2">
                <span>{{ show[0].movie_title }}</span>
                <span
                  >{{ showTime.ss_start_show_time }} -
                  {{ showTime.ss_end_show_time }}</span
                >
                <span
                  >{{ showTime.total_admits }}/ {{ showTime.total_seats }}</span
                >
              </div>
              <button type="button" class="btn-transparent chevron">
                <img
                  src="@/assets/img/icons/primary/chevron-down.svg"
                  height="24"
                  width="24"
                />
              </button>
            </div>
            <b-collapse :id="`table-${showIndex}`">
              <table border="1">
                <tr>
                  <td colspan="1">{{ $tc("movie", 1) }}</td>
                  <td colspan="1">{{ show[0].movie_title }}</td>
                </tr>
                <tr>
                  <td colspan="1">{{ $t("time") }}</td>
                  <td colspan="1">
                    {{ showTime.ss_start_show_time }} -
                    {{ showTime.ss_end_show_time }}
                  </td>
                </tr>
                <tr>
                  <td colspan="1">{{ $t("admits") }}</td>
                  <td colspan="1">{{ showTime.total_admits }}</td>
                </tr>
                 <tr v-if="AUTO_ADMIT_TICKET_AFTER_SHOW == 'Y'">
                  <td colspan="1">{{ $t("entered") }}</td>
                  <td colspan="1">{{ showTime.entered - parseInt(showTime.auto_entered || 0) || 0 }}</td>
                </tr>

                <tr v-if="AUTO_ADMIT_TICKET_AFTER_SHOW == 'Y'">
                  <td colspan="1">{{ $t("autoentered") }}</td>
                  <td colspan="1">{{ showTime.auto_entered || 0 }}</td>
                </tr>
               
                <tr v-else>
                  <td colspan="1">{{ $t("entered") }}</td>
                  <td colspan="1">{{ showTime.entered || 0 }}</td>
                </tr>
                <tr>
                  <td colspan="1">{{ $t("unpaid") }} {{ $t("booking") }}</td>
                  <td colspan="1">{{ showTime.unpaid_bookings }}</td>
                </tr>
                <tr>
                  <td colspan="1">{{ $t("available") }}</td>
                  <td colspan="1">{{ showTime.seats_available }}</td>
                </tr>
                <tr>
                  <td colspan="1">{{ $tc("screen", 1) }}</td>
                  <td colspan="1">{{ showTime.screen_name }}</td>
                </tr>
                <tr>
                  <td colspan="1">{{ 'Occ %' }}</td>
                  <td colspan="1">{{ parseFloat((showTime.total_admits / showTime.total_seats) * 100).toFixed(2) }}%</td>
                </tr>
              </table>
            </b-collapse>
          </div>
        </article>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { BASEURL } from "@/config/index";
import MasterService from "@/services/MasterService";
import ReportService from "@/services/ReportsService";
import vue from "vue";
import PosService from "../../../services/PosService";
import { groupBy } from "lodash";
import moment from "moment";
import CinemasService from "../../../services/CinemasService";
import NoRecords from "@/components/Partials/NoRecords.vue";
import * as XLSX from 'xlsx';

export default {
  components: {
    NoRecords
  },
  data() {
    return {
      FilePathArray: [],
      BASEURL,
      PdfPath: "",
      ExcelPath: "",
      DailyReportDataV2: [],
      Cinemas: [],
      isRoleID: true,
      CinemasCopy: [],
      selectedCinema: { cine_id: null },
      searchCinema: "",
      options: {
        text: {
          shadowEnable: true,
          shadowColor: "#000000",
          color: "#D3D3D3",
          fontSize: 14,
          fontFamily: "Helvetica",
          dynamicPosition: false,
          hideText: true
        },
        progress: {
          color: "#9ACD32",
          backgroundColor: "#D3D3D3",
          inverted: false
        },
        layout: {
          height: 20,
          width: 75,
          verticalTextAlign: 61,
          horizontalTextAlign: 43,
          zeroOffset: 0,
          strokeWidth: 30,
          progressPadding: 0,
          type: "line"
        }
      },
      scheduleShows: [],
      CineScreens: [],
      selectedScreen: { screen_id: null },
      selectedDate: new Date()
    };
  },
  computed: {
    ...mapGetters([
      // GET LIST ONLY
      "getPosUsersList",
      "AUTO_ADMIT_TICKET_AFTER_SHOW",
      "getPaymentTypesList",
      "getCinemasList",
      "getDailyConcessionReportList",
      // Flags
      "getDailyReportsIsCinema",
      "getDailyReportsIsExcelDownload",
      // Rendered List
      "getDailyReportList",
      "getDailyRefundList",
      // Selected Dates
      "getDailyReportToDate",
      "getDailyReportFromDate",
      // Selected Dropdowns
      "getDailyReportSelectedPaymentMode",
      "getDailyReportSelectedPosUser",
      "getDailyReportSelectedCinema",
      // FILEs
      "getDailyExcelFileName",
      // PSD
      "getDailyPDFFileName",
      // GET TOTALs
      "getGrandTotal",
      "getBoxOfficeTotal",
      "getConcessionOfficeTotal",
      "getPaymentSummary",
      "getFilmSummary",
      "getUserWiseSummary",
      "getRefundSummary",
      "getConcessionDailyReportData",
      "grandTotalForConcessionsReport",
      "getConcessionDailyExcelFileName",
      "getConcessionDailyPdfFileName"
    ]),
    isMobile() {
      return this.$store.getters.getIsMobile;
    }
  },
  watch: {
    "$store.getters.getSelectedDropDownCinema": function(CinemaObj) {
      if (CinemaObj) {
        this.cineDropDownHandler({
          event: null,
          name: "Cinema",
          selectedItem: CinemaObj,
          index: null
        });
      }
    }
  },
  beforeMount() {
    let roleid = this.secureStore.get("USINFO").role_id;
    if (true) {
      this.isRoleID = false;
    }
    let cinemaId =
      this.secureStore.get("USINFO") &&
      this.secureStore.get("USINFO")["cinema_id"]
        ? this.secureStore.get("USINFO").cinema_id
        : null;
    this.cinema_id = cinemaId;
    this.getCinemaList(cinemaId);
    //this.getOccupancyStatus({cinemaId})
  },
  mounted() {
    let CinemaObj = this.$store.getters.getSelectedDropDownCinema;
    if (CinemaObj) {
      this.selectedCinema.cine_name = CinemaObj.cine_name;
      this.cineDropDownHandler({
        event: null,
        name: "Cinema",
        selectedItem: CinemaObj,
        index: null
      });
    }
  },
   beforeRouteLeave(to, from, next) {
    this.removeDownloadedFile();
    next();
  },
  created() {
    window.addEventListener("unload", event => {
      this.removeDownloadedFile();
    });
  },
  beforeDestroy() {
    this.removeDownloadedFile();
  },
  methods: {
      ExportExcel(type, fn, dl) {
      var elt = this.$refs.exportable_table;
      var wb = XLSX.utils.table_to_book(elt, {sheet:"Sheet JS"});
      return dl ?
      XLSX.write(wb, {bookType:type, bookSST:true, type: 'base64'}) :
      XLSX.writeFile(wb, fn || (('DistributorCollectionReport.') + (type || 'xlsx')));
    },
  
    ...mapActions([
      // FETCH FROM MASTER STORE
      "fetchCinemasList",
      "fetchPosUsersList",
      "fetchPaymentTypesList",

      // FETCH LIST ONLY
      "fetchDailyReportListv2",
      "onDailyReportDateHandler",
      "onDailyReportDropdownHandler",
      "onDailyReportFlagHandler",
      "onFetchDailyConcessionReport",
      // ON RESET ALL
      "onResetDailyReportStoreState"
    ]),

    onSelectCinema(cinema) {
      this.$store.dispatch("selectDropdownCinema", cinema);
    },

    onSearchCinema: function() {
      if (this.searchCinema && this.searchCinema.length > 0) {
        this.Cinemas = this.CinemasCopy.filter(x => {
          if (
            x.cine_name.toLowerCase().includes(this.searchCinema.toLowerCase())
          ) {
            return x;
          }
        });
      } else {
        this.Cinemas = this.CinemasCopy;
      }
    },

    onFetchReport() {
      this.getOccupancyStatus();
    },

    getCinemaList: function(cine_id) {
      this.Cinemas = [];

      MasterService.GetCinemas({ cine_id: cine_id })
        .then(response => {
          const { data } = response;
          if (data.status && data.Records.length > 0) {
            this.Cinemas = data.Records;
            this.CinemasCopy = data.Records;
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch(this._CatchError);
    },

    async getOccupancyStatus() {
      if (!this.selectedCinema.cine_id) {
        vue.toasted.show("Please select a cinema");
        return;
      }

      let loader = vue.$loading.show();

      let payload = {
        cinema_id: this.selectedCinema.cine_id,
        selectedDate: moment(this.selectedDate || moment()).format("DD-MM-YYYY")
      };

      if (this.selectedScreen.screen_id)
        payload.screen_id = this.selectedScreen.screen_id;

      let { data } = await ReportService.GetOccupancyReport(payload).catch(
        e => {
          vue.toasted.show(e.message || "Please try later");
        }
      ).finally(() => {
         loader.hide();
      })

      if (data && data.status) {
        let movieData = groupBy(data.Records, "md_id");
        this.PdfPath = data.PdfPath;
        if(data.ExcelPath) {
          this.ExcelPath = data.ExcelPath;
          this.FilePathArray.push(data.ExcelPath)
        }
        let tempArray = [];
        for (let key in movieData) {
          if (movieData.hasOwnProperty(key)) {
            let sortedByScreen = movieData[key].sort(
              (a, b) => a.screen_id - b.screen_id
            );

            tempArray.push(sortedByScreen);
          }
        }
        this.scheduleShows = tempArray;
        console.log("this.scheduleShows", this.scheduleShows);
      } else {
        this.scheduleShows = [];
        vue.toasted.show(data.message || "Please try later");
      }
    },
      removeDownloadedFile() {
      let payload = {
        fileArray: this.FilePathArray
      };
      MasterService.RemoveDownloadedFile(payload)
        .then(response => {
          const { data } = response;
        })
        .catch(error => {
          console.log("error :", error);
        });
    },
    async cineDropDownHandler({ event, name, selectedItem, index }) {
      this.selectedScreen = { screen_id: null };
      this.selectedCinema = selectedItem;

      let loader = vue.$loading.show();
      let { data: ScreenData } = await CinemasService.GetActiveScreenByCinema({
        tableName: "screens",
        activekey: "screen_is_active",
        conditionColName: "cinema_id",
        conditionId: this.selectedCinema.cine_id,
        limit: 100,
        currentPage: 1,
        searchValue: "",
        searchKey: "screen_name",
        columnName: "",
        orderBy: "screen_id"
      }).catch(e => {
        vue.toasted.show(e.message || "Please try later");
      });
      loader.hide();
      if (ScreenData && ScreenData.status) {
        ScreenData.Records = ScreenData.Records.filter(
          x => x.screen_layout_active
        ).sort((a, b) => a.screen_id - b.screen_id);

        this.CineScreens = ScreenData.Records || [];
      } else {
        vue.toasted.show(data.message || "Please try later");
      }
    },
    onDateHandler(d) {
      if (!(d instanceof Date && !isNaN(d))) d = new Date();

      this.selectedDate = new Date(d);
    },
    cineScreenDropDownHandler({ event, name, selectedItem, index }) {
      this.selectedScreen = selectedItem;
    }
  },
};
</script>

<style>
.border-bottom-black {
  border-bottom: 1px solid #787878 !important;
}

.mobile-occupancy-report table {
  width: 100%;
}

.mobile-occupancy-report * {
  border-color: #eaeaed;
}

.mobile-occupancy-report .mobile-occupancy-sub-report {
  margin: 0 -15px 20px;
}

.mobile-occupancy-report .mobile-occupancy-sub-report td {
  padding: 10px;
}

.mobile-occupancy-report .mobile-occupancy-sub-report tr > td:first-child {
  font-weight: bold;
  background-color: #f5f5f7;
}

.mobile-occupancy-report .mobile-occupancy-sub-report .sub-report-toggle {
  padding: 10px 15px;
  font-weight: bold;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.mobile-occupancy-report
  .mobile-occupancy-sub-report
  .sub-report-toggle
  span:not(:last-child)::after {
  content: "|";
  padding: 0 4px;
}
</style>



// WEBPACK FOOTER //
// src/components/Pages/ReportsContainer/occupancyReports.vue